import { h, Component, FunctionalComponent } from 'preact'
import tracker from '../../components/tracker/publish'
import Analytics from '../analytics/Analytics'

const isIE11 = typeof navigator !== 'undefined' && !!navigator.userAgent.match(/Trident\/7\.0/)

export interface GAEvent {
  eventCategory: string
  eventAction: string
  eventLabel: unknown
}

export interface TrackingLinkProps extends JSX.HTMLAttributes {
  tag?: string|typeof Component
  track: unknown
  gaEvents?: GAEvent
}

const TrackingLink: FunctionalComponent<TrackingLinkProps> = (props) => {
  const { tag: Component = 'a', gaEvents, onClick, ...restProps } = props

  return (
    <Component
      {...restProps} onClick={(e: MouseEvent) => {
        tracker.trackEvent('userevent', props.track)
        if (props.gaEvents) {
          Analytics.send(props.gaEvents.eventCategory, props.gaEvents.eventAction, props.gaEvents.eventLabel)
        }
        if (typeof props.onClick === 'function') {
          props.onClick(e)
        } else if (props.href && isIE11 && typeof window !== 'undefined') {
          window.location.href = props.href
        }
      }}
    >{props.children}</Component>
  )
}

export default TrackingLink
